import React, { useState } from "react";
import { Icon, Input, Select } from "antd";
const { Option } = Select;
import _ from "lodash";
import dayjs from "dayjs";
// reactstrap components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    CardBody,
    Media
} from "reactstrap";
// core components
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReduxBlockUi from "react-block-ui/redux";
import MessageBox from "../../../components/ui/MessageBox";
import ScaleContainer from "../../../components/ui/ScaleContainer";
import ClipLoader from "react-spinners/ClipLoader";
import { StickyContainer } from "react-sticky";
import "react-block-ui/style.css";
import { useForm } from "react-hook-form";
import ResizeObserver from 'resize-observer-polyfill';

import Constants from "../../../config/Constants";
import * as Helper from "../../../utils/Helper";
import * as UnitHelper from "../../../utils/UnitHelper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unit/SimpleBatchAddRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import UnitView from "../../../components/units/UnitView";
import SimpleBatchUnitForm from "./forms/SimpleBatchUnitForm";
import CollapseUnitView from "../../../components/ui/CollapseUnitView";
import BatchExportScreen from "./BatchExportScreen";
import UnitFields from "./fields/";
import { Actions as TaskActions } from "../../../redux/TaskRedux";
import { TaskTypes } from "../../../utils/TaskHelper"
import { HotKeys } from "react-hotkeys";

import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import "./SimpleBatchAddScreen.css";

const uid = UIDs.screens.admin.unit.simplebatchadd;

const simpleUnitTypes = ['POSB1', 'POSC1', 'POSC2', 'POSC3', 'PSSD1', 'PSSD2', 'PSSO1', 'PSSD2_AUDIO', 'POLA1']; //添加新单元，要在多语言中添加title
const spokenUnits = ['POKA1', 'POKA2', 'POKA3', 'POKA4', 'PSKA5'];

function isComprehensiveUnit(unit) {
    return unit.unitType === 'PSSO1';
}

function isSameType(a, b) {
    if (_.isNil(a) || _.isNil(b)) {
        return true;
    }

    if (_.isNumber(a)) {
        return _.isNumber(b);
    }

    if (_.isBoolean(a)) {
        return _.isBoolean(b);
    }

    if (_.isDate(a)) {
        return _.isDate(b);
    }

    if (_.isString(a)) {
        return _.isString(b);
    }

    if (_.isError(a)) {
        return _.isError(b);
    }

    if (_.isArray(a)) {
        if (_.isArray(b)) {
            if (a.length === b.length) {
                for (let i = 0; i < a.length; ++i) {
                    if (!isSameType(a[i], b[i])) {
                        return false;
                    }
                }
                return true;
            }
        }
    }

    if (_.isObject(a)) {
        if (_.isObject(b)) {
            let ka = _.keys(a);
            let kb = _.keys(b);
            if (ka.length === kb.length) {
                if (_.difference(ka, kb).length === 0) {
                    for (let i = 0; i < ka.length; ++i) {
                        let k = ka[i];
                        if (!isSameType(a[k], b[k])) {
                            return false;
                        }
                    }
                    return true;
                }
            }
        }
    }
    return false;
}

function SubUnitViewItem(props) {
    const { hoverUnitId, editUnitId, showErrors, data, index } = props;

    const unit = data;
    //const showUnit = unit.saved;
    const modified = unit.modified;
    const showUnit = true;
    const width = props.width - 20;
    //const height = parseInt(width * 720 / 400);
    //const height = (showUnit && (!isDragging)) ? undefined : 130;
    const height = undefined;
    const style = {
        position: 'relative',
        backgroundColor: 'white',
        //marginBottom: 10,
        width: width + 20,
        height: height ? (height + 20) : undefined,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 20,
        overflow: 'hidden',
    };

    const opacity = 1;
    const borderStyle = {
        border: '0px solid transparent',
    };

    if (hoverUnitId === data.id) {
        borderStyle.border = '0px solid #ccc';
    }

    if (editUnitId === data.id) {
        //borderStyle.border = '1px solid blue';
        //style.backgroundColor = '#fffdf7';
        borderStyle.border = '0px solid #fdaf2c';
        style.backgroundColor = '#fff8ec';
    }

    if (showErrors && (showErrors.indexOf(data.id) >= 0)) {
        borderStyle.border = '0px solid red';
    }

    if (borderStyle.border.indexOf('transparent') >= 0) {
        borderStyle.borderTopWidth = 0;
        borderStyle.borderTopColor = '#eee';
        borderStyle.borderTopStyle = 'solid';
    }

    const unitType = props.findUnitType(unit.unitType);
    const isHoverView = (hoverUnitId === data.id);
    const isEditView = (editUnitId === data.id);
    //const scale = width / 400;
    const scale = 1.0;

    const unitViewUnitType = unit.unitType === "POKA3" ? "POKA3Simple"
        : unit.unitType === "POKA4" ? "POKA4Simple"
        : unit.unitType === "POLA1" ? "POLA1Simple"
        : unit.unitType;

    return (
        <div style={{ ...borderStyle, opacity }}>
            <div style={{ ...style }} onClick={() => props.onEditUnit(unit.id)}
                 onMouseEnter={() => props.onMouseEnter(unit.id)}
                 onMouseLeave={() => props.onMouseLeave(unit.id)}>
                {modified ?
                 (<div style={{zIndex: 1, position: 'absolute', left: 0, top: 0,
                               backgroundColor: '#fc5045', color: '#fff',
                               paddingLeft: 6, paddingRight: 6, fontSize: 12,
                               paddingTop: 6, paddingBottom: 6, borderRadius: 0}}>
                      {props.t('modified')}
                  </div>) : null}
                {showUnit ?
                 (<div style={{ width: width, height: height, minHeight: 80 }}
                       onClick={() => props.onEditUnit(unit.id)}>
                      <div style={{display: 'flex', flexDirection: 'row', marginBottom: 10}}>
                          {modified ?
                             (<div style={{backgroundColor: 'transparent', color: '#fff',
                             paddingLeft: 3, paddingRight: 3, fontSize: 12,
                             paddingTop: 6, paddingBottom: 6, borderRadius: 0}}>
                             {props.t('modified')}
                             </div>) : null}
                          <div>{'(' + (index + 1) + ')【' + unitType.title + '】'}</div>
                      </div>
                      <ScaleContainer width={width} height={height} scale={scale}>
                          <UnitView unitType={unitViewUnitType} cover={unit.cover} data={unit.data}
                                    scale={scale} prefix={/*(index + 1) + '. '*/''}
                                    viewMode={Constants.UnitViewModeEnum.SimpleBatch}
                                    editMode={Constants.UnitViewModeEnum.SimpleBatch}
                                    showAnswer={true} width={width} height={height} />
                      </ScaleContainer>
                  </div>) :
                 (<div style={{ display: 'flex', flexDirection: 'column',
                                alignItems: 'center', justifyContent: 'center',
                                width: width, height: height, overflow: 'hidden' }}
                       onClick={() => props.onEditUnit(unit.id)}>
                      <div>{props.t('unitName', {name: unit.unitType})}</div>
                      <div>{props.t('clickToEdit')}</div>
                  </div>)}
                {isHoverView ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: 24,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onShowAddSubUnit(unit.parentId, true);
                       }}>
                      <Icon type="plus" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
                {isHoverView ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: 60,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onDeleteUnit(unit.id);
                       }}>
                      <Icon type="delete" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
                {isHoverView && (!isEditView) ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: 96,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onEditUnit(unit.id);
                       }}>
                      <Icon type="form" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
                {isHoverView ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: (isEditView ? 96 : 96 + 36),
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onCopyUnit(unit.id);
                       }}>
                      <Icon type="copy" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
            </div>
        </div>
    );
}

function ComprehensiveSubView(props) {
    const { hoverUnitId, editUnitId, showErrors, data, index, subUnitTypes } = props;
    const unit = data;
    const isEditView = (editUnitId === data.id);
    return (<div style={{paddingLeft: 20}}>
                {unit.subunits ?
                 unit.subunits.map((subunit, j) =>
                     (<SubUnitViewItem t={props.t} key={subunit.id} index={j} data={subunit}
                                       width={props.width - 24}
                                       hoverUnitId={props.hoverUnitId}
                                       editUnitId={props.editUnitId}
                                       showErrors={props.showErrors}
                                       findUnitType={props.findUnitType}
                                       findUnitById={props.findUnitById}
                                       onViewRef={props.onViewRef}
                                       onShowAddSubUnit={props.onShowAddSubUnit}
                                       onMouseEnter={props.onMouseEnter}
                                       onMouseLeave={props.onMouseLeave}
                                       onMoveUnit={props.onMoveUnit}
                                       onReorderUnit={props.onReorderUnit}
                                       onCopyUnit={props.onCopyUnit}
                                       onEditUnit={props.onEditUnit}
                                       onDeleteUnit={props.onDeleteUnit}/>)) : null}
                {unit.addsub ?
                 (<div className='subunittypes' style={{marginTop: 20, marginBottom: 20, marginRight: 20}}>
                      <div className='dlghead'>
                          {props.t('selectSubUnitType')}
                          <div style={{position: 'absolute', right: 20, top: 10, cursor: 'pointer',
                                       zIndex: 10, fontWeight: 'normal', fontSize: 20, color: '#999'}}
                               onClick={() => props.onShowAddSubUnit(unit.id, false)}>
                              X
                          </div>
                      </div>
                      <div className='dlgbody'>
                          <div className='typelist'>
                              {
                                  subUnitTypes().map((item, k) =>
                                      (<UnitTypeItem t={props.t} key={k} index={k} data={item}
                                                     onAddUnit={(index, unitType) => {
                                                         props.onAddSubUnit(unit, unitType);
                                                     }}/>)
                                  )
                              }
                          </div>
                      </div>
                  </div>) : null}
                {((!unit.addsub) && unit.subunits && unit.subunits.length === 0) ?
                 (<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center',
                               marginTop: 20, marginBottom: 20}}>
                      <div id='add_sub_unit_btn' className='plainbtn'
                           style={{paddingLeft: 30, paddingRight: 30, color: '#000'}}
                           onClick={() => {
                               props.onShowAddSubUnit(unit.id, true);
                           }}>
                          + {props.t('addSubUnit')}
                      </div>
                  </div>) : null}
            </div>);
}

function UnitViewItem(props) {
    const { hoverUnitId, editUnitId, showErrors, data, index } = props;
    const [{ isDragging }, drag] = useDrag({
        item: { type: 'unit_view',
                index: index,
                data: data },
        end(item, monitor) {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                const { type, data, index } = monitor.getItem();
                props.onReorderUnit(data, index);
            } else {
                const { type, data, index } = monitor.getItem();
                props.onMoveUnit(data, index);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [{ canDrop, isOver }, drop] = useDrop({
        accept: ["unit_view"],
        drop: () => ({ index: index }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
        hover: (item) => {
            if (item.data.id !== data.id) {
                if (item.type === "unit_view") {
                    props.onMoveUnit(item.data, index);
                }
            }
        },
    });

    const unit = data;
    //const showUnit = unit.saved;
    const modified = unit.modified;
    const showUnit = true;
    const width = props.width - 20;
    //const height = parseInt(width * 720 / 400);
    //const height = (showUnit && (!isDragging)) ? undefined : 130;
    const height = undefined;
    const style = {
        position: 'relative',
        backgroundColor: 'white',
        //marginBottom: 10,
        width: width + 20,
        height: height ? (height + 20) : undefined,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 20,
        overflow: 'hidden',
    };

    const opacity = isDragging ? 0 : 1;
    const borderStyle = {
        border: '1px solid transparent',
    };

    if (hoverUnitId === data.id) {
        borderStyle.border = '1px solid #ccc';
    }

    if (editUnitId === data.id) {
        //borderStyle.border = '1px solid blue';
        //style.backgroundColor = '#fffdf7';
        borderStyle.border = '1px solid #fdaf2c';
        style.backgroundColor = '#fff8ec';
    }

    const editUnit = props.findUnitById(editUnitId);
    if (editUnit && editUnit.parentId === data.id) {
        borderStyle.border = '1px solid #fdaf2c';
    }

    if (showErrors && (showErrors.indexOf(data.id) >= 0)) {
        borderStyle.border = '1px solid red';
    }

    if (borderStyle.border.indexOf('transparent') >= 0) {
        borderStyle.borderTopWidth = 1;
        borderStyle.borderTopColor = '#eee';
        borderStyle.borderTopStyle = 'solid';
    }

    const unitType = props.findUnitType(unit.unitType);
    const isHoverView = (hoverUnitId === data.id);
    const isEditView = (editUnitId === data.id);
    //const scale = width / 400;
    const scale = 1.0;

    const unitViewUnitType = unit.unitType === "POKA3" ? "POKA3Simple"
        : unit.unitType === "POKA4" ? "POKA4Simple"
        : unit.unitType === "POLA1" ? "POLA1Simple"
        : unit.unitType;

    const isComprehensive = isComprehensiveUnit(unit);
    return (
        <div ref={(node) => {
                 drag(drop(node));
                 props.onViewRef(unit, node);
             }} style={{ ...borderStyle, opacity }}>
            <div style={{ ...style }} onClick={() => props.onEditUnit(unit.id)}
                 onMouseEnter={() => props.onMouseEnter(unit.id)}
                 onMouseLeave={() => props.onMouseLeave(unit.id)}>
                {modified ?
                 (<div style={{zIndex: 1, position: 'absolute', left: 0, top: 0,
                               backgroundColor: '#fc5045', color: '#fff',
                               paddingLeft: 6, paddingRight: 6, fontSize: 12,
                               paddingTop: 6, paddingBottom: 6, borderRadius: 0}}>
                      {props.t('modified')}
                  </div>) : null}
                {showUnit ?
                 (<div style={{ width: width, height: height, minHeight: 80 }}
                       onClick={() => props.onEditUnit(unit.id)}>
                      <div style={{display: 'flex', flexDirection: 'row', marginBottom: 10}}>
                          {modified ?
                             (<div style={{backgroundColor: 'transparent', color: '#fff',
                             paddingLeft: 3, paddingRight: 3, fontSize: 12,
                             paddingTop: 6, paddingBottom: 6, borderRadius: 0}}>
                             {props.t('modified')}
                             </div>) : null}
                          <div>{(index + 1) + '.【' + unitType.title + '】'}</div>
                      </div>
                      <ScaleContainer width={width} height={height} scale={scale}>
                          <UnitView unitType={unitViewUnitType} cover={unit.cover} data={unit.data}
                                    scale={scale} prefix={/*(index + 1) + '. '*/''}
                                    viewMode={Constants.UnitViewModeEnum.SimpleBatch}
                                    editMode={Constants.UnitViewModeEnum.SimpleBatch}
                                    showAnswer={true} width={width} height={height} />
                      </ScaleContainer>
                  </div>) :
                 (<div style={{ display: 'flex', flexDirection: 'column',
                                alignItems: 'center', justifyContent: 'center',
                                width: width, height: height, overflow: 'hidden' }}
                       onClick={() => props.onEditUnit(unit.id)}>
                      <div>{props.t('unitName', {name: unit.unitType})}</div>
                      <div>{props.t('clickToEdit')}</div>
                  </div>)}
                {isHoverView ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: 24,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onDeleteUnit(unit.id);
                       }}>
                      <Icon type="delete" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
                {isHoverView && (!isEditView) ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: 60,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onEditUnit(unit.id);
                       }}>
                      <Icon type="form" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
                {/*屏蔽这个判断，综合题也要可以复制*/}
                {isHoverView /*&& (!isComprehensive)*/ ?
                 (<div style={{position: 'absolute', zIndex: 10, top: 0, right: (isEditView ? 60 : 96),
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               width: 30, height: 30, color: '#fff',
                               backgroundColor: 'transparent', cursor: 'pointer'}}
                       onClick={(e) => {
                           e.stopPropagation();
                           props.onCopyUnit(unit.id);
                       }}>
                      <Icon type="copy" style={{fontSize: 18, color: '#999'}}/>
                  </div>) : null}
            </div>
            {isComprehensive ?
             (<ComprehensiveSubView {...props}/>) : null}
        </div>
    );
}

function UnitViewArea(props) {
    const { hoverUnitId, editUnitId, showAffix, showErrors, items } = props;
    const [{ dragItem, canDrop, isOver }, drop] = useDrop({
        accept: ["unit_type", "unit_view"],
        drop: () => ({index: 0, isDropArea: true}),
        collect: (monitor) => ({
            dragItem: monitor.getItem(),
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isUnitView = (dragItem && dragItem.type === "unit_view");
    const isActive = canDrop && isOver
    let backgroundColor = '#fff';
    if (!isUnitView) {
        if (isActive) {
            backgroundColor = '#f3fcf3';
        } else if (canDrop) {
            backgroundColor = '#f3f3f3';
        }
    }

    const width = props.width - 20;
    const style = (items.length > 0) ? {
        //border: '1px dashed gray',
        width: width + 20,
        //padding: 10,
    } : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #e9ecef',
        width: width + 20,
        height: 130 + 20,
        padding: 10,
    };

    let title = null;
    if (isUnitView) {
        title = props.t('moveUpDownToSort');
    } else {
        if (canDrop) {
            title = isActive ? props.t('releaseToAddUnit') : props.t('moveToAddUnit');
        } else {
            title = props.t('dragUnitTypeToAddUnit');
        }
    }

    const unitWidth = width;
    const unitHeight = undefined;
    let editUnit = null;
    for (let i = 0; i < items.length; ++i) {
        if (items[i].id === editUnitId) {
            editUnit = items[i];
            break;
        }
    }
    return (
        <div ref={drop} style={{ ...style, backgroundColor }}>
            {items.length > 0 ? null :
             (<div style={{display: 'flex', flexDirection: 'row',
                           alignItems: 'center', justifyContent: 'center',
                           marginBottom: (items.length > 0 ? 10 : 0)}}>
                  {title}
              </div>)}
            {items.map((item, i) =>
                (<UnitViewItem t={props.t} key={item.id} index={i} data={item}
                               width={props.width}
                               hoverUnitId={hoverUnitId}
                               editUnitId={editUnitId}
                               showErrors={showErrors}
                               subUnitTypes={props.subUnitTypes}
                               findUnitType={props.findUnitType}
                               findUnitById={props.findUnitById}
                               onViewRef={props.onViewRef}
                               onMouseEnter={props.onMouseEnter}
                               onMouseLeave={props.onMouseLeave}
                               onMoveUnit={props.onMoveUnit}
                               onReorderUnit={props.onReorderUnit}
                               onShowAddSubUnit={props.onShowAddSubUnit}
                               onAddSubUnit={props.onAddSubUnit}
                               onCopyUnit={props.onCopyUnit}
                               onEditUnit={props.onEditUnit}
                               onDeleteUnit={props.onDeleteUnit}/>))}
        </div>
    )
}

function UnitTypeItem(props) {
    const { data, index } = props;
    /*
    const [{ opacity }, drag] = useDrag({
        item: { type: 'unit_type',
                index: index,
                data: data },
        end(item, monitor) {
            const { type, data, index } = monitor.getItem()
            const didDrop = monitor.didDrop();
            if (didDrop) {
                const dropResult = monitor.getDropResult();
                if (dropResult.isDropArea) {
                    props.onAddUnit(-1, data);
                }
            }
        },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.4 : 1,
        }),
    });
    */

    const style = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #707070',
        borderRadius: 6,
        backgroundColor: 'white',
        padding: '8px 12px',
        marginRight: '20px',
        marginBottom: '20px',
        width: 160,
        float: 'left',
        cursor: 'pointer',
    };

    const textStyle = {
        maxWidth: 120,
        textAlign: "center",
        color: '#707070',
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    };
    return (
        <div style={{ ...style }} onClick={() => {
                 props.onAddUnit(-1, data);
             }}>
            {/*<i className={`iconfont icon-${data.id}`} style={{marginRight: 8, fontSize: 16, color: '#666'}} />*/}
            <div style={textStyle}>{data.title}</div>
        </div>
    );
}

class SimpleBatchAddScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: this._handleLoadScreenViewAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.CHANGE_TITLE_ASYNC]: { done: this._handleChangeTitleAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.DELETE_UNIT_ASYNC]: { done: this._handleDeleteUnitAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_ASYNC]: { done: this._handleSaveUnitAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_SILENT_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.REORDER_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.BATCH_ADD_UNIT_ASYNC]: { done: this._handleBatchAddUnitAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.BATCHADD_AND_CREATE_UNIT_ASYNC]: { done: null, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            hoverUnitId: null,
            activeTab: 0,
            scrollTop: 0,
            unitViewPos: {},
            editTitle: false,
            title: '',
            showUnitTypes: false,
            showUnitTypesAtBottom: false,
            showPreview: false,
            showExport: false,
            bodyWidth: 0,
            bodyHeight: 0,
        };

        this.pendingSaveUnits = {};
        this.unitViews = {};
        this.unitForms = {};
        this.localVars.navParams = NavigationService.getNavParams(props);
        if (props.courseId) {
            this.localVars.navParams.courseId = props.courseId;
        }
        if (props.sectionId) {
            this.localVars.navParams.sectionId = props.sectionId;
        }
        if (props.homework) {
            this.localVars.navParams.homework = props.homework;
        }
        if (props.composition) {
            this.localVars.navParams.composition = props.composition;
        }
        if (props.edit) {
            this.localVars.navParams.edit = props.edit;
        }

        if (this.localVars.navParams.showExport) {
            this.state.showExport = true;
        }
    }

    componentDidMount() {
        super.componentDidMount();

        window.onbeforeunload = (e) => {
            if (!this._checkAllUnitSaved()) {
                e.returnValue = this.props.t('pleaseSaveUnitsFirst');
                return e.returnValue;
            }
            return undefined;
        }

        const { sectionId, edit, courseType } = this.localVars.navParams;
        window.addEventListener('scroll', this._handleScroll);

        const now = dayjs();
        const defaultTitle = this.props.t('defaultTitle',
                                          {year: now.year(), month: now.month() + 1, day: now.date()});
        this.props.loadScreenViewAsync({sectionId: (sectionId || ''), edit,
                                        defaultTitle: defaultTitle, courseType});
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        /* NOTE: 会导致编辑保存后输入框失去焦点
        let hotkeysScope = this.refs.hotkeysScope;
        hotkeysScope && hotkeysScope.focus();
        */
    }

    componentWillUnmount() {
        window.onbeforeunload = undefined;
        window.removeEventListener('scroll', this._handleScroll);

        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }
    }

    updateUnitViewPosLater = () => {
        if (this._updatePosTimer) {
            return;
        }
        this._updatePosTimer = setTimeout(this.updateUnitViewPos, 200);
    };

    initScroll = () => {
        //切换对话单元时，有时会将菜单设置为浮动，样式乱了
        //切换单元时，让滚动条滚动一下
        if(document.getElementById("leftEditUnitBody")){
            document.getElementById("leftEditUnitBody").scrollTop = 30;
            document.getElementById("leftEditUnitBody").scrollTop = 0;
        }
    }

    scrollToUnit = (index) => {
        const { unitDataList } = this.props.localState;
        let i = index;
        if (i < 0) {
            i = unitDataList.length - 1;
        }

        if (i >= 0 && i < unitDataList.length) {
            const lastUnit = unitDataList[i];
            const lastView = this.unitViews[lastUnit.id];
            if (lastView) {
                document.documentElement.scrollTop = lastView.offsetTop;
                document.body.scrollTop = lastView.offsetTop;
            }
        }
    };

    updateUnitViewPos = () => {
        const { unitDataList } = this.props.localState;
        if (this._updatePosTimer) {
            clearTimeout(this._updatePosTimer);
            this._updatePosTimer = null;
        }

        let height = 0;
        let unitViewPos = {};
        for (let i = 0; i < unitDataList.length; ++i) {
            const unitId = unitDataList[i].id;
            unitViewPos[unitId] = height;

            let view = this.unitViews[unitId];
            if (view) {
                height += view.clientHeight;
                height += 10;
            }
        }

        this.setState({unitViewPos}, () => {
            if (this._lastAddedUnitIndex !== undefined) {
                this.scrollToUnit(this._lastAddedUnitIndex);
                this._lastAddedUnitIndex = undefined;
            }
        });
    };

    _updateViewSize = () => {
        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._bodyRef) {
            const width = this._bodyRef.clientWidth;
            const height = this._bodyRef.clientHeight;
            this.setState({bodyWidth: width, bodyHeight: height});
        }
    };

    _updateViewSizeLater = () => {
        if (this._updateViewSizeTimer) {
            return;
        }
        this._updateViewSizeTimer = setTimeout(this._updateViewSize, 100);
    };

    setupBodyRef = (r) => {
        if (!r) {
            return;
        }

        if (this._bodyRef === r) {
            return;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }

        this._bodyRef = r;
        this._resizeObserver = new ResizeObserver(this._updateViewSizeLater);
        this._resizeObserver.observe(this._bodyRef);

        this._updateViewSizeLater();
    };

    setupUnitForm = (unitId, r) => {
        this.unitForms[unitId] = r;
    };

    onFormChange = (unitId, key, value) => {
        this.saveFormLater();
    };

    saveFormLater = () => {
        if (this._saveFormTimer) {
            return;
        }
        this._saveFormTimer = setTimeout(this.saveForm, 200);
    };

    saveUnitLater = (unitId) => {
        this.pendingSaveUnits[unitId] = unitId;
        if (this._saveUnitTimer) {
            return;
        }

        if (this._savingPendingUnits) {
            return;
        }

        this._saveUnitTimer = setTimeout(() => this.savePendingUnits(), 200);
    };

    async savePendingUnits() {
        if (this._saveUnitTimer) {
            clearTimeout(this._saveUnitTimer);
            this._saveUnitTimer = null;
        }

        if (this.isActionExecuting(ActionTypes.SAVE_UNIT_ASYNC) ||
            this.isActionExecuting(ActionTypes.SAVE_UNIT_SILENT_ASYNC))
        {
            this._saveUnitTimer = setTimeout(() => this.savePendingUnits(), 200);
            return;
        }

        this._savingPendingUnits = true;
        do {
            const unitIds = Object.keys(this.pendingSaveUnits);
            if (unitIds.length === 0) {
                break;
            }

            const unitId = unitIds[0];
            delete this.pendingSaveUnits[unitId];
            const unit = this.findUnitById(unitId);
            if (unit) {
                await this._handleSaveUnit(unit, true);
            }

            if (this._abortSavingUnits) {
                this.pendingSaveUnits = {};
                break;
            }
        } while (true);
        this._savingPendingUnits = false;
    };

    saveForm = () => {
        const { editUnitId } = this.props.localState;
        if (this._saveFormTimer) {
            clearTimeout(this._saveFormTimer);
            this._saveFormTimer = null;
        }

        const form = this.unitForms[editUnitId];
        const unit = this.findUnitById(editUnitId);
        if (form && unit) {
            this.onSaveForm(unit, form.getValues({nest: true}), true, true);
            /*
            form.handleSubmit((newFormData) => {
                this.onSaveForm(unit, newFormData, true);
            })();
            */
            /*
            form.triggerValidation().then((ok) => {
                if (ok) {
                    this.onSaveForm(unit, form.getValues({nest: true}), true);
                }
            });
            */
        }
    };

    hotkeysKeyMap = {
        CANCEL: "alt+q",
    }

    hotkeysHandler = {
        CANCEL: () => this._handleCancelEdit(),
    }

    _handleScroll = () => {
        let top = document.documentElement.scrollTop;
        if (top === undefined) {
            top = document.body.scrollTop;
        }

        if (this.state.scrollTop !== top) {
            this.setState({scrollTop: top});
        }
    };

    buildTypeList(unitTypeList) {
        const typeList = [
            { type: "A", name: this.props.t("reading"), list: [] },
            { type: "B", name: this.props.t("fillBlank"), list: [] },
            { type: "C", name: this.props.t("choice"), list: [] },
            { type: "D", name: this.props.t("question"), list: [] },
            { type: "E", name: this.props.t("sortSentence"), list: [] },
            { type: "F", name: this.props.t("replace"), list: [] },
            { type: "G", name: this.props.t("sheet"), list: [] },
            { type: "H", name: this.props.t("classification"), list: [] },
            { type: "I", name: this.props.t("sorts"), list: [] },
            { type: "J", name: this.props.t("writing"), list: [] },
            { type: "K", name: this.props.t("spoken"), list: [] },
            { type: "L", name: this.props.t("drawing"), list: [] },
            { type: "M", name: this.props.t("linkLine"), list: [] },
            { type: "U", name: this.props.t("files"), list: [] },
            { type: "V", name: this.props.t("composition"), list: [] },
            { type: "", name: this.props.t("others"), list: [] },
        ];

        const typesMap = {
        };

        for (let i = 0; i < typeList.length; ++i) {
            const it = typeList[i];
            typesMap[it.type] = it;
        }

        for (let i = 0; i < unitTypeList.length; ++i) {
            const it = unitTypeList[i];
            if (it.id === 'CP') {
                // 跳过复合单元
                continue;
            }

            let groupId = it.id[2];
            if (it.id === 'PSDO1' || it.id === 'PSSD1') {
                // 写作题单独分类
                groupId = 'V';
            }

            let set = typesMap[groupId];
            if (!set) {
                // others
                set = typesMap[""];
            }
            set.list.push(it);
        }

        for (let i = 0; i < typeList.length; ++i) {
            const it = typeList[i];
            it.list.sort((a, b) => {
                return a.id > b.id ? 1 : -1;
            });
        }
        return typeList;
    }

    renderUnitViews() {
        const { editUnitId, unitDataList, showErrors } = this.props.localState;
        if (unitDataList.length < 1) {
            return null;
        }

        let showAffix = false;
        const editPos = this.state.unitViewPos[editUnitId];
        if (editPos !== undefined) {
            const marginTop = 220;
            if (this.state.scrollTop > editPos + marginTop) {
                //showAffix = true;
            }
        }

        let width = this.state.bodyWidth / 2 - 1;
        if (width < 0) {
            width = 0;
        }
        return (<UnitViewArea t={this.props.t} items={unitDataList}
                              width={width}
                              hoverUnitId={this.state.hoverUnitId}
                              editUnitId={editUnitId}
                              showAffix={showAffix}
                              showErrors={showErrors}
                              onViewRef={(item, r) => {
                                  this.unitViews[item.id] = r;
                              }}
                              subUnitTypes={this.subUnitTypes}
                              findUnitType={this.findUnitType}
                              findUnitById={this.findUnitById}
                              onMouseEnter={(unitId) => {
                                  this.setState({hoverUnitId: unitId});
                              }}
                              onMouseLeave={(unitId) => {
                                  if (this.state.hoverUnitId === unitId) {
                                      this.setState({hoverUnitId: null});
                                  }
                              }}
                              onShowAddSubUnit={(unitId, show) => {
                                  this.props.showAddSubUnit(unitId, show);
                              }}
                              onAddSubUnit={(item, unitType) => {
                                  this._checkAllUnitSavedAsync().then((ok) => {
                                      if (ok) {
                                          const { ownerType, ownerId } = this.localVars.navParams;
                                          const data = UnitView.defaultData(unitType.id);
                                          this.props.addSubUnit(item.id, {unitType, ownerType, ownerId: null, data}, this.saveUnitLater);
                                      }
                                  });

                              }}
                              onMoveUnit={(item, index) => {
                                  if (this._lastMoveId && this._lastMoveId !== item.id) {
                                      this.props.moveUnit(this._lastMoveId, this._lastMoveIndex);
                                  }

                                  this._lastMoveId = item.id;
                                  this._lastMoveIndex = index;
                                  if (!this._lastMoveTimer) {
                                      this._lastMoveTimer = setTimeout(() => {
                                          this._lastMoveTimer = null;
                                          this.props.moveUnit(this._lastMoveId, this._lastMoveIndex);
                                          this._lastMoveId = null;
                                          this._lastMoveIndex = null;
                                          //this.updateUnitViewPosLater();
                                      }, 100);
                                  }
                              }}
                              onReorderUnit={(item, index) => {
                                  this.props.reorderAsync(item.id, index);
                              }}
                              onCopyUnit={(unitId) => {
                                  const curUnit = this.findUnitById(unitId);
                                  if (curUnit) {
                                      if (curUnit.parentId) {
                                          const { ownerType, ownerId } = this.localVars.navParams;
                                          const index = -1;
                                          const unitType = {id: curUnit.unitType,
                                                            duration: curUnit.duration};
                                          const data = _.cloneDeep(curUnit.data);
                                          this.props.addSubUnit(curUnit.parentId, {unitType, ownerType, ownerId: null, data, changed: true, skipValidate: (!curUnit.modified)}, this.saveUnitLater);
                                          this._lastAddedUnitIndex = index;
                                          this.initScroll();
                                      } else {
                                          const { ownerType, ownerId } = this.localVars.navParams;
                                          const index = -1;
                                          const unitType = {id: curUnit.unitType,
                                                            duration: curUnit.duration};
                                          const data = _.cloneDeep(curUnit.data);
                                          this.props.addUnit(index, {unitType, ownerType, ownerId: null, data, changed: true, skipValidate: (!curUnit.modified)}, this.saveUnitLater);
                                          this._lastAddedUnitIndex = index;
                                          this.initScroll();
                                      }
                                  }
                              }}
                              onEditUnit={(unitId) => {
                                  this.props.editUnit(unitId);
                                  this.setState({activeTab: 1});
                                  this.initScroll();
                              }}
                              onDeleteUnit={(unitId) => {
                                  this._handleDeleteUnit(unitId);
                              }}/>);
    }

    renderPreviewUnit(data, index, width, courseType) {
        const unit = data;
        //const showUnit = unit.saved;
        const showUnit = true;
        //const height = parseInt(width * 720 / 400);
        const height = undefined;
        const style = {
            position: 'relative',
            border: '1px solid transparent',
            backgroundColor: 'white',
            //marginBottom: 10,
            width: width + 20,
            height: height ? (height + 20) : undefined,
            padding: 10,
            overflow: 'hidden',
        };

        const opacity = 1;
        const isHoverView = false;
        const isEditView = false;
        //const scale = width / 400;
        const scale = 1.0;

        const unitType = this.findUnitType(unit.unitType);
        const unitViewUnitType = unit.unitType === "POKA3" ? "POKA3Simple"
              : unit.unitType === "POKA4" ? "POKA4Simple"
              : unit.unitType === "POLA1" ? "POLA1Simple"
              : unit.unitType;
        return (
            <div style={{ opacity }}>
                <div style={{ ...style }}>
                    {(courseType === 5 || courseType === 6) && (simpleUnitTypes.indexOf(unit.unitType) >= 0 || spokenUnits.indexOf(unit.unitType) >= 0) ?
                     (<div style={{ width: width, height: height, minHeight: 80 }}>
                          <div>{(index + 1) + '.【' + unitType.title + '】'}</div>
                          <ScaleContainer width={width} height={height} scale={scale}>
                              <UnitView unitType={unitViewUnitType} cover={unit.cover} data={unit.data}
                                        scale={scale} prefix={/*(index + 1) + '. '*/''}
                                        viewMode={Constants.UnitViewModeEnum.SimpleBatch}
                                        showAnswer={false} width={width} height={height} />
                          </ScaleContainer>
                      </div>) :
                     (<div style={{ display: 'flex', flexDirection: 'column', width: 400 + 10 }}>
                          <div>
                              {(index + 1) + '. '}
                          </div>
                          <CollapseUnitView
                              unit={unit}
                              collapsedHeight={200}
                              width={400 - 10}
                              height={400}
                              containerStyle={{ border: "1px solid #eee", borderRadius: 10, marginTop: 5, padding: 5 }}
                              contentStyle={{paddingLeft: 5, paddingRight: 5}}
                              viewMode={Constants.UnitViewModeEnum.SimpleBatch}
                          />
                      </div>)}
                </div>
            </div>
        );
    }

    renderPreviewUnits() {
        const { editUnitId, unitDataList, showErrors, courseType } = this.props.localState;
        if (unitDataList.length < 1) {
            return null;
        }

        const items = unitDataList;
        //const width = 400;
        const width = this.state.bodyWidth - 80;
        const style = {
            //border: '1px dashed gray',
            width: width + 20,
            padding: 20,
        };

        const unitWidth = width;
        const unitHeight = undefined;
        let editUnit = null;

        return (
            <div style={{ ...style }}>
                {items.map((item, i) =>
                    this.renderPreviewUnit(item, i, width, courseType))}
            </div>
        );
    }

    renderUnitType(item, i) {
        return (<UnitTypeItem t={this.props.t} key={i} index={i} data={item}
                              onAddUnit={(index, unitType) => {
                                  const { ownerType, ownerId } = this.localVars.navParams;
                                  const data = UnitView.defaultData(unitType.id);
                                  this.props.addUnit(index, {unitType, ownerType, ownerId: null, data}, this.saveUnitLater);
                                  this._lastAddedUnitIndex = index;
                                  this.setState({showUnitTypes: false});
                                  this.initScroll();
                              }}/>);
    }

    renderUnitTypeList(set, key) {
        const list = set.list;
        if (list.length === 0) {
            return null;
        }
        return (<div key={key} style={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{color: '#505050', fontWeight: 'bold', marginBottom: 12}}>
                        {set.name}
                    </div>
                    <div>
                    {
                        list.map((item, i) => {
                            this.hotkeysKeyMap[`${item.id}`] = [`${item.id[0].toLowerCase()} ${item.id[1]}`, `${item.id[0].toUpperCase()} ${item.id[1]}`];
                            this.hotkeysHandler[`${item.id}`] = () => { this.props.selectUnitType(item) };
                            return this.renderUnitType(item, i);
                        })
                    }
                    </div>
                </div>);
    }

    validUnitTypes() {
        const { unitTypeList } = this.props.localState;
        let unitTypes = [];
        let validTypes = [];
        let allTypes = new Map();
        const { course, homework, composition } = this.localVars.navParams;
        if (homework) {
            validTypes.push('POSC2');
            validTypes.push('POSC3');
            validTypes.push('POSC1');
            validTypes.push('POSB1');
            validTypes.push('PSSD2');
            validTypes.push('PSSO1');
            validTypes.push('POKA1');
            validTypes.push('POKA2');
            validTypes.push('POKA3');
            validTypes.push('POKA4');
            validTypes.push('PSKA5');
            validTypes.push('POLA1');
        } else if (composition) {
            validTypes.push('PSSD1');
        } else {
            validTypes.push('POSC2');
            validTypes.push('POSC3');
            validTypes.push('POSC1');
            validTypes.push('POSB1');
            validTypes.push('PSSD2');
            validTypes.push('PSSD1');
            validTypes.push('PSSO1');
            validTypes.push('POKA1');
            validTypes.push('POKA2');
            validTypes.push('POKA3');
            validTypes.push('POKA4');
            validTypes.push('PSKA5');
            validTypes.push('POLA1');
        }

        for (let i = 0; i < unitTypeList.length; ++i) {
            const it = unitTypeList[i];
            allTypes.set(it.id, it);
        }

        let pssd2Unit = null;
        for (let i = 0; i < validTypes.length; ++i) {
            const it = allTypes.get(validTypes[i]);
            if (it) {
                if (spokenUnits.indexOf(it.id) >= 0) {
                    it.title = this.props.t(it.id.toLowerCase());
                }

                if(simpleUnitTypes.indexOf(it.id) >= 0) {
                    it.title = this.props.t(it.id.toLowerCase());
                }

                unitTypes.push(it);
                if (it.id === 'PSSD2') {
                    pssd2Unit = it;
                }
            }
        }

        if (pssd2Unit) {
            const tmp = _.clone(pssd2Unit);
            tmp.id = 'PSSD2_AUDIO';
            tmp.title = this.props.t('recordAudio');
            unitTypes.push(tmp);
        }
        return unitTypes;
    }

    findUnitType = (unitTypeId) => {
        const { unitTypeList } = this.props.localState;
        for (let i = 0; i < unitTypeList.length; ++i) {
            if (unitTypeList[i].id === unitTypeId) {
                return unitTypeList[i];
            }
        }

        if (unitTypeId === 'PSSD2_AUDIO') {
            const tmp = {};
            tmp.id = 'PSSD2_AUDIO';
            tmp.title = this.props.t('recordAudio');
            return tmp;
        }
        return {id: unitTypeId, title: unitTypeId}
    };

    subUnitTypes = () => {
        const { unitTypeList } = this.props.localState;
        let unitTypes = [];
        var validTypes = [];
        let allTypes = new Map();

        validTypes.push('POSC2');
        validTypes.push('POSC3');
        validTypes.push('POSC1');
        validTypes.push('POSB1');
        validTypes.push('PSSD2');
        validTypes.push('POKA1');
        validTypes.push('POKA2');
        validTypes.push('POKA3');
        validTypes.push('POKA4');
        validTypes.push('PSKA5');
        validTypes.push('POLA1');

        for (let i = 0; i < unitTypeList.length; ++i) {
            const it = unitTypeList[i];
            allTypes.set(it.id, it);
        }

        let pssd2Unit = null;
        for (let i = 0; i < validTypes.length; ++i) {
            const it = allTypes.get(validTypes[i]);
            if (it) {
                if (spokenUnits.indexOf(it.id) >= 0) {
                    it.title = this.props.t(it.id.toLowerCase());
                }

                if(simpleUnitTypes.indexOf(it.id) >= 0) {
                    it.title = this.props.t(it.id.toLowerCase());
                }

                unitTypes.push(it);
                if (it.id === 'PSSD2') {
                    pssd2Unit = it;
                }
            }
        }

        if (pssd2Unit) {
            const tmp = _.clone(pssd2Unit);
            tmp.id = 'PSSD2_AUDIO';
            tmp.title = this.props.t('recordAudio');
            unitTypes.push(tmp);
        }
        return unitTypes;
    };

    renderUnitTypes() {
        const { unitTypeList, unitType } = this.props.localState;
        const unitTypes = this.validUnitTypes();
        return (<div className='unittypes' style={{
                         top: (this.state.showUnitTypesAtBottom ? undefined : 20),
                         bottom: (this.state.showUnitTypesAtBottom ? 20 : undefined),
                     }}>
                    <div className='dlghead'>
                        {this.props.t('selectUnitType')}
                        <div style={{position: 'absolute', right: 20, top: 10, cursor: 'pointer',
                                     zIndex: 10, fontWeight: 'normal', fontSize: 20, color: '#999'}}
                             onClick={() => this.setState({showUnitTypes: false})}>
                            X
                        </div>
                    </div>
                    <div className='dlgbody'>
                        <div className='typelist'>
                            {
                                unitTypes.map((item, i) => {
                                    return this.renderUnitType(item, i);
                                })
                            }
                        </div>
                    </div>
                </div>);
    }

    buildFormData(unit, newFormData, silent, skipValidate) {
        const EditFields = UnitFields[SimpleBatchUnitForm.toFieldTypeName(unit.unitType)];
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData, skipValidate)
        } catch (e) {
            if (!silent) {
                if (e.notValidate) {
                    //MessageBox.danger({ text: e.message, duration: 5000 });
                    const [index, subIndex] = this.findUnitIndexById(unit.id);
                    //MessageBox.danger({ text: this.props.t('unitDoesNotValidate', {index: index + 1}), duration: 5000 });
                    MessageBox.danger({ text: this.props.t('unitHasInvalidData', {index: index + 1}), duration: 5000 });
                } else {
                    const [index, subIndex] = this.findUnitIndexById(unit.id);
                    MessageBox.danger({ text: this.props.t('unitHasInvalidData', {index: index + 1}), duration: 5000 });
                }
            }
            return null;
        }
        return fieldsData;
    }

    onSaveForm(unit, newFormData, silent, skipValidate, cb) {
        const fieldsData = this.buildFormData(unit, newFormData, silent, skipValidate);
        if (!fieldsData) {
            return;
        }

        const isCompositeUnit = ('CP' === unit.unitType);
        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            if (!isCompositeUnit) {
                fieldsData.data = {
                    ...fieldsData.data,
                    title: Helper.combineTranslation(newFormData, "title"),
                }
            }
        }

        let duration = newFormData.duration;
        if (isCompositeUnit) {
            // 复合单元duration为所有子单元的duration相加
            duration = 0;
            fieldsData.data.units.forEach((subUnit) => {
                duration += parseInt(subUnit.duration);
            });
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: duration,
                cover: newFormData.cover,
            }
        }

        let updateData = _.cloneDeep(submitData);
        if (updateData.data.language) {
            updateData.data.newLanguage = updateData.data.language;
            delete updateData.data.language;
        }

        this.props.updateUnit(unit.id, updateData);
        this.saveUnitLater(unit.id);

        if (cb) {
            cb();
        } else {
            if (!silent) {
                this.props.editUnit(null);
            }
        }
    }

    renderUnitForm(unit, i) {
        const { editUnitId } = this.props.localState;
        const visible = (editUnitId === unit.id);
        const pos = this.state.unitViewPos[unit.id];
        return (<div key={unit.id} style={{position: 'relative',
                                           marginTop: pos,
                                           display: (visible ? 'flex' : 'none'),
                                           flexDirection: 'column',
                                           width: (visible ? undefined : 0),
                                           height: (visible ? undefined : 0)}}>
                    {/*
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center',
                                 height: 40, paddingLeft: 10, paddingRight: 10,
                                 borderBottom: '1px solid gray'}}>
                        <div style={{flex: 1}}>{this.props.t('editUnit', {name: unit.unitType})}</div>
                        <button type="submit" className="btn btn-info btn-sm" onClick={() => {
                                    const form = this.unitForms[unit.id];
                                    if (form) {
                                        form.handleSubmit((newFormData) => {
                                            this.onSaveForm(unit, newFormData);
                                        })();
                                    }
                                }}>
                            {this.props.t("save")}
                        </button>
                        &nbsp;
                        <button type="button" className="btn btn-default btn-sm" onClick={() => {
                                    this.props.editUnit(null);
                                }}>
                            {this.props.t("cancel")}
                        </button>
                    </div>
                     */}
                    <div style={{flex: 1, overflow: 'hidden', marginBottom: 20}}>
                        <SimpleBatchUnitForm key={unit.id + unit.unitType}
                                             data={{ unitType: unit.unitType, formData: unit.data, commonFieldValues: { duration: unit.duration, cover: unit.cover, title: unit.data.title }, id: unit.id }}
                                             resourceId={unit.resourceId}
                                             noHeader={true}
                                             onForm={this.setupUnitForm}
                                             onChange={(key, value) => {
                                                 this.onFormChange(unit.id, key, value);
                                             }}/>
                    </div>
                </div>);
    }

    renderUnitForms() {
        const { editUnitId, unitDataList } = this.props.localState;
        return (<div style={{ position: 'relative',
                              /*width: (editUnitId ? 800 : 0),*/
                              /*height: (editUnitId ? 480 : 0),*/
                              /*border: (editUnitId ? '1px solid gray' : undefined),*/
                              backgroundColor: '#fff',
                              }}>
                    {unitDataList.map((item, i) => this.renderUnitForm(item, i))}
                </div>);
    }

    _handleDeleteUnit(unitId) {
        const { unitDataList } = this.props.localState;
        const [index, subIndex] = this.findUnitIndexById(unitId);
        confirmAlert({
            title: subIndex >= 0 ? this.props.t("confirmToDeleteSub", {index: index + 1, subIndex: subIndex + 1}) : this.props.t("confirmToDelete", {index: index + 1}),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        const parentUnitId = unitDataList[index].id;
                        this.props.deleteUnitAsync(unitId);
                        this.updateUnitViewPosLater();
                        if (subIndex >= 0) {
                            this.saveUnitLater(parentUnitId);
                        }
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveTitle() {
        this.setState({editTitle: false});
        if (!this.state.title.trim()) {
            return;
        }

        const { title, sectionId } = this.props.localState;
        if (title !== this.state.title) {
            this.props.changeTitleAsync({sectionId: sectionId, title: this.state.title});
        }
    }

    _handleAddUnit = (bottom) => {
        this._checkAllUnitSavedAsync().then((ok) => {
            if (ok) {
                this.setState({showUnitTypes: true, showUnitTypesAtBottom: (bottom ? true : false)});
            }
        });
    };

    _handlePreviewUnit = () => {
        const { unitDataList } = this.props.localState;
        if (unitDataList.length === 0) {
            MessageBox.danger({ text: this.props.t('pleaseAddUnits'), duration: 5000 });
            return;
        }

        this._checkAllUnitSavedAsync().then((ok) => {
            if (ok) {
                this.setState({showPreview: true});
            }
        });
    };

    _handleEditUnit = () => {
        this.setState({showPreview: false});
    };

    _realChangeUnitType = (value) => {
        const { editUnitId } = this.props.localState;
        if (!editUnitId) {
            return;
        }

        const editUnit = this.findUnitById(editUnitId);
        if (!editUnit) {
            return;
        }

        const unitType = value;
        const data = {...UnitView.defaultData(unitType)};
        for (let k in editUnit.data) {
            if (data[k] !== undefined) {
                if (k !== 'answerType') {
                    if (isSameType(data[k], editUnit.data[k])) {
                        data[k] = editUnit.data[k];
                    }
                }
            }
            else {
                // NOTE: 新类型里没有的字段不保留, 否则可能导致服务器端序列化出错
                /*
                if (k !== 'title') {
                    data[k] = _.clone(editUnit.data[k]);
                }
                */
            }
        }

        if (this._saveFormTimer) {
            clearTimeout(this._saveFormTimer);
            this._saveFormTimer = null;
        }

        delete this.unitForms[editUnitId];

        this.props.changeUnitType({unitId: editUnitId, unitType: unitType, data: data});

        this.saveUnitLater(editUnitId);
    };

    _handleChangeUnitType = (value) => {
        confirmAlert({
            title: this.props.t("sureToDo"),
            message: this.props.t("confirmToChangeType"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this._realChangeUnitType(value);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    };

    _handleSaveEdit = (unit) => {
        if (!unit) {
            const { editUnitId } = this.props.localState;
            if (editUnitId) {
                unit = this.findUnitById(editUnitId);
            }
        }

        const form = this.unitForms[unit.id];
        if (!form) {
            return;
        }

        form.handleSubmit((newFormData) => {
            this.onSaveForm(unit, newFormData, false, false, () => {
                const { editUnitId } = this.props.localState;
                const editUnit = editUnitId ? this.findUnitById(editUnitId) : null;
                if (editUnit) {
                    this.saveUnitAsync(editUnit, false);
                }
            });
        })();
    };

    async saveUnitAsync(unit, silent) {
        if (unit.parentId) {
            const parentUnit = this.findUnitById(unit.parentId);
            if (parentUnit) {
                if (parentUnit.isNew) {
                    throw new Error("parent not saved!!!");
                }

                const { sectionId, title } = this.props.localState;
                const { courseId } = this.localVars.navParams;
                const { order, unitType, ownerType, resourceId, dataType, data, commonFieldValues } = parentUnit;
                const dataObj = _.cloneDeep(data);
                if (dataObj.newLanguage) {
                    dataObj.language = dataObj.newLanguage;
                }

                const subIndex = parentUnit.subunits.indexOf(unit);
                if (subIndex < 0) {
                    throw new Error("invalid subindex!!!");
                }

                const subData = {...unit.data};
                if (subData.newLanguage) {
                    subData.language = subData.newLanguage;
                }

                dataObj.practices[subIndex] = {
                    unitType: unit.unitType,
                    data: JSON.stringify(subData),
                };

                let practices = [];
                for (let i = 0; i < dataObj.practices.length; ++i) {
                    if (dataObj.practices[i]) {
                        dataObj.practices[i].unitType = Helper.getRealUnitType(dataObj.practices[i].unitType);
                        practices.push(dataObj.practices[i]);
                    }
                }
                dataObj.practices = practices;

                let vo = { courseId, sectionTitle: title, localId: unit.id, id: (parentUnit.isNew ? "" : parentUnit.remoteId), unitType: Helper.getRealUnitType(unitType), ownerType, order, ownerId: sectionId, resourceId, dataType, data: JSON.stringify(dataObj), ...commonFieldValues };

                if (silent) {
                    await this.props.saveUnitSilentAsync(vo, unit.modified);
                } else {
                    await this.props.saveUnitAsync(vo, unit.modified);
                }
            }
        } else {
            const { sectionId, title } = this.props.localState;
            const { courseId } = this.localVars.navParams;
            const { order, unitType, ownerType, resourceId, dataType, data, commonFieldValues } = unit;
            const dataObj = _.cloneDeep(data);
            if (dataObj.newLanguage) {
                dataObj.language = dataObj.newLanguage;
            }

            let vo = { courseId, sectionTitle: title, localId: unit.id, id: (unit.isNew ? "" : unit.remoteId), unitType: Helper.getRealUnitType(unitType), ownerType, order, ownerId: sectionId, resourceId, dataType, data: JSON.stringify(dataObj), ...commonFieldValues };

            if (silent) {
                await this.props.saveUnitSilentAsync(vo, unit.modified);
            } else {
                await this.props.saveUnitAsync(vo, unit.modified);
            }
        }
    };

    _handleCancelEdit = () => {
        this.props.cancelEdit();
    };

    _handleExportUnit = () => {
        const { title, unitDataList } = this.props.localState;
        if (unitDataList.length === 0) {
            MessageBox.danger({ text: this.props.t('pleaseAddUnits'), duration: 5000 });
            return;
        }

        this._checkAllUnitSavedAsync().then((ok) => {
            if (ok) {
                /*
                  NavigationService.navigateToPageByUID(this, UIDs.screens.admin.unit.batchexport,
                  {title, units: unitDataList});
                */
                this.setState({showExport: true});
            }
        });
    };

    renderLeftHead(editUnit) {
        const unitTypes = this.validUnitTypes();
        return (<div className='lefthead'>
                    {this.props.t('unitType')}
                    <Select value={editUnit.unitType} style={{ marginLeft: 8, width: 220 }}
                            onChange={(value) => this._handleChangeUnitType(value)}>
                        {unitTypes.map((it, i) =>
                            (<Option value={it.id} key={i}>{it.title}</Option>))}
                    </Select>
                </div>);
    }

    renderLeftBody(editUnit) {
        //const unit = editUnit;
        const unitDataList = this.expandedUnitDataList();
        return (<div style={{flex: 1}}>
                    {unitDataList.map((unit, i) => {
                        if ((editUnit.id !== unit.id) && (!unit.modified)) {
                            return null;
                        }
                        return (<div key={unit.id + unit.unitType}
                                     style={{display: (editUnit.id !== unit.id) ? 'none' : 'block'}}>
                                    <SimpleBatchUnitForm key={unit.id + unit.unitType}
                                                         data={{ unitType: unit.unitType, formData: unit.data, commonFieldValues: { duration: unit.duration, cover: unit.cover, title: unit.data.title }, id: unit.id }}
                                                         resourceId={unit.resourceId}
                                                         noHeader={true}
                                                         onForm={this.setupUnitForm}
                                                         onChange={(key, value) => {
                                                             this.onFormChange(unit.id, key, value);
                                                         }}/>
                                </div>);
                    })}
                    {/*
                    <SimpleBatchUnitForm key={unit.id + unit.unitType}
                                         data={{ unitType: unit.unitType, formData: unit.data, commonFieldValues: { duration: unit.duration, cover: unit.cover, title: unit.data.title }, id: unit.id }}
                                         resourceId={unit.resourceId}
                                         noHeader={true}
                                         onForm={this.setupUnitForm}
                                         onChange={(key, value) => {
                                             this.onFormChange(unit.id, key, value);
                                         }}/>
                     */}
                </div>);
    }

    renderLeftFoot() {
        const { title, unitDataList, editUnitId } = this.props.localState;
        const editUnit = editUnitId ? this.findUnitById(editUnitId) : null;
        return (<div className='leftfoot' style={{paddingRight: 20}}>
                    <div className='yellowbtn mleft20' onClick={() => {
                             this._handleSaveEdit(editUnit)
                         }}>
                        {this.props.t('save')}
                    </div>
                    <div className='blackbtn mleft20' onClick={() => {
                             this._handleCancelEdit()
                         }}>
                        {this.props.t('cancel')}
                    </div>
                </div>);
    }

    renderNormal() {
        const { title, unitDataList, editUnitId } = this.props.localState;
        const editUnit = editUnitId ? this.findUnitById(editUnitId) : null;

        let hasSimpleUnit = false;
        unitDataList.forEach((it) => {
            if (simpleUnitTypes.indexOf(it.unitType) >= 0) {
                hasSimpleUnit = true;
            }
        });

        const isSaving = (this.isActionExecuting(ActionTypes.SAVE_UNIT_ASYNC) ||
                          this.isActionExecuting(ActionTypes.SAVE_UNIT_SILENT_ASYNC));
        return (<div className='simplebatchadd'>
                    <div className='head'>
                        <div className='whitebtn' onClick={() => {
                                 this._handleGoBack()
                             }}>
                            {this.props.t('goBack')}
                        </div>
                        {this.state.editTitle ?
                         (<Input value={this.state.title} maxLength={50} autoFocus={true}
                                 style={{marginLeft: 40, width: 200}}
                                 placeholder={this.props.t('pleaseInputSectionTitle')}
                                 onChange={(e) => this.setState({title: e.target.value})}
                                 onPressEnter={() => this._handleSaveTitle()}
                                 onBlur={() => this._handleSaveTitle()}/>) :
                         (<div className='title mleft40'>
                              {title}
                          </div>)}
                        {this.state.editTitle ? null :
                         (<div style={{cursor: 'pointer', marginLeft: 8, marginBottom: 4}} onClick={() => {
                                   this.setState({editTitle: true, title: title});
                               }}>
                              <Icon type={'form'} style={{ color: '#fff', fontSize: 18 }} />
                          </div>)}
                        <div style={{flex: 1}}/>
                        <div className='bluebtn2' onClick={() => {
                                 if (!isSaving) {
                                     this._handleSaveAll(false);
                                 }
                             }}>
                            {isSaving ? <ClipLoader css="width:16px;height:16px;margin-right:4px;" color="#fff"/> : null}
                            {isSaving ? this.props.t('saving') : this.props.t('save')}
                        </div>
                        <div className='yellowbtn mleft20' onClick={() => {
                                 this._handleAddUnit()
                             }}>
                            {this.props.t('addUnit')}
                        </div>
                        <div className='yellowbtn mleft20' onClick={() => {
                                 this._handlePreviewUnit()
                             }}>
                            {this.props.t('previewUnit')}
                        </div>
                        {hasSimpleUnit ?
                         (<div className='yellowbtn mleft20' onClick={() => {
                                   this._handleExportUnit()
                               }}>
                              {this.props.t('exportUnit')}
                          </div>) : null}
                    </div>
                    <DndProvider backend={HTML5Backend}>
                        <div className='body'>
                            <div className='left'>
                                {editUnit ? this.renderLeftHead(editUnit) : null}
                                <div className='leftbody'>
                                    <StickyContainer id={"leftEditUnitBody"} className='panel'>
                                        {editUnit ? this.renderLeftBody(editUnit) : null}
                                    </StickyContainer>
                                </div>
                                {/*editUnit ? this.renderLeftFoot() : null*/}
                            </div>
                            <div className='right'>
                                {unitDataList && unitDataList.length > 0 ?
                                 (<div className='righthead'>
                                      {this.props.t('addedUnits', {count: unitDataList.length})}
                                  </div>) : null}
                                {this.state.showUnitTypes ? this.renderUnitTypes() : null}
                                <div className='rightbody'>
                                    <div className='panel'>
                                        {this.renderUnitViews()}
                                        <div style={{display: 'flex', alignItems: 'center',
                                                     justifyContent: 'center', marginTop: 20, marginBottom: 20}}>
                                            <div id='add_new_unit_btn' className='plainbtn'
                                                 style={{paddingLeft: 50, paddingRight: 50}}
                                                 onClick={() => {
                                                     const btn = document.getElementById("add_new_unit_btn");
                                                     const rc = btn.getBoundingClientRect();
                                                     if (rc.top > this.state.bodyHeight / 2) {
                                                         this._handleAddUnit(true);
                                                     } else {
                                                         this._handleAddUnit();
                                                     }
                                                 }}>
                                                + {this.props.t('addNewUnit')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.isActionExecuting(ActionTypes.SAVE_UNIT_ASYNC) ||
                             this.isActionExecuting(ActionTypes.DELETE_UNIT_ASYNC) ?
                             (<div className='layer'>
                                  <LoadingIndicator />
                              </div>) : null}
                        </div>
                    </DndProvider>
                </div>);
    }

    renderPreview() {
        const { title, unitDataList, editable, editUnitId } = this.props.localState;
        const editUnit = editUnitId ? this.findUnitById(editUnitId) : null;

        let hasSimpleUnit = false;
        unitDataList.forEach((it) => {
            if (simpleUnitTypes.indexOf(it.unitType) >= 0) {
                hasSimpleUnit = true;
            }
        });
        return (<div className='simplebatchadd'>
                    <div className='head'>
                        <div className='whitebtn' onClick={() => {
                                 this._handleGoBack()
                             }}>
                            {this.props.t('goBack')}
                        </div>
                        <div className='title mleft40'>
                            {title}
                        </div>
                        <div style={{flex: 1}}/>
                        {editable ?
                         (<div className='yellowbtn' onClick={() => {
                                   this._handleEditUnit()
                               }}>
                              {this.props.t('editUnit')}
                          </div>) : null}
                        {hasSimpleUnit ?
                         (<div className='yellowbtn mleft20' onClick={() => {
                                   this._handleExportUnit()
                               }}>
                              {this.props.t('exportUnit')}
                          </div>) : null}
                    </div>
                    <div className='body'>
                        <div className='panel'>
                            {this.renderPreviewUnits()}
                        </div>
                    </div>
                </div>);
    }

    renderExport() {
        const { title, unitDataList } = this.props.localState;
        return (<BatchExportScreen title={title} units={unitDataList} onClose={() => {
                                       if (this.localVars.navParams.showExport) {
                                           this._handleGoBack();
                                       } else {
                                           this.setState({showExport: false});
                                       }
                                   }}/>);
    }

    render() {
        // before initialization is done, we show loading icon
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <LoadingIndicator />;
        }

        const { editable } = this.props.localState;
        return (<div ref={this.setupBodyRef}
                     style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0}}>
                    {this.state.showExport ? this.renderExport() :
                     (this.state.showPreview || (!editable) ? this.renderPreview() : this.renderNormal())}
                </div>);
    }

    abortSaveUnits() {
        this._abortSavingUnits = true;
        this.props.abortSaveUnitAsync();
        this.props.abortSaveUnitSilentAsync();
    }

    _realGoBack = () => {
        this.abortSaveUnits();
        if (this.props.onClose) {
            const { courseId } = this.localVars.navParams;
            const { sectionId, unitDataList } = this.props.localState;
            if (unitDataList.length > 0) {
                var datas = [];
                for (let i = 0; i < unitDataList.length; ++i) {
                    if (!unitDataList[i].modified) {
                        let unitId = unitDataList[i].remoteId || unitDataList[i].id;
                        datas.push({
                            ...unitDataList[i],
                            id: unitId,
                            courseId,
                            sectionId,
                            data: JSON.stringify(unitDataList[i].data),
                        });
                    }
                }

                if (datas.length > 0) {
                    this.props.onClose(datas);
                } else {
                    this.props.onClose();
                }
            } else {
                this.props.onClose();
            }
        } else {
            NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
        }
    };

    _handleGoBack = () => {
        if (this.state.showPreview) {
            this.setState({showPreview: false});
            return;
        }

        if (!this._checkAllUnitSaved(true)) {
            confirmAlert({
                title: this.props.t("sureToDo"),
                message: this.props.t("confirmToGoBack"),
                buttons: [
                    {
                        label: this.props.t("yes"),
                        onClick: () => {
                            this._realGoBack();
                        }
                    },
                    {
                        label: this.props.t("no")
                    }
                ]
            });
            return;
        }

        this._realGoBack();
    }

    _handleCancel = () => {
        confirmAlert({
            title: this.props.t("confirmToCancel"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this._handleGoBack();
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    findUnitIndexById = (unitId) => {
        const { unitDataList } = this.props.localState;
        for (let i = 0; i < unitDataList.length; ++i) {
            const unit = unitDataList[i];
            if (unit.id === unitId) {
                return [i, -1];
            }

            if (unit.subunits) {
                for (let j = 0; j < unit.subunits.length; ++j) {
                    if (unit.subunits[j].id === unitId) {
                        return [i, j];
                    }
                }
            }
        }
        return [-1, -1];
    }

    findUnitById = (unitId) => {
        const { unitDataList } = this.props.localState;
        const [index, subIndex] = this.findUnitIndexById(unitId);
        if (index >= 0) {
            let unit = unitDataList[index];
            if (subIndex >= 0) {
                return unit.subunits[subIndex];
            }
            return unit;
        }
        return null;
    }

    async _handleSaveUnit(unit, silent) {
        const unitId = unit.id;
        const form = this.unitForms[unitId];
        if (!form) {
            return false;
        }

        if (silent) {
            if (!unit.changed) {
                return false;
            }
        }

        const ok = await form.triggerValidation();
        if (!ok) {
            if (!silent) {
                const [index, subIndex] = this.findUnitIndexById(unit.id);
                MessageBox.danger({ text: this.props.t('unitHasInvalidData', {index: index + 1}), duration: 5000 });
            }
            return true;
        }

        const skipValidate = unit.skipValidate ? true : false;
        if (!this.buildFormData(unit, form.getValues({nest: true}), silent, skipValidate)) {
            return true;
        }

        try {
            await this.saveUnitAsync(unit, silent);
        } catch (e) {
            console.warn("saveUnitAsync error", e);
            return true;
        }
        return false;
    }

    editErrorUnit(unitId) {
        /*
        const { editUnitId } = this.props.localState;
        const editUnit = this.findUnitById(editUnitId);
        if ((!editUnit) || (!editUnit.modified)) {
            this.props.editUnit(unitId);
        }
        */
        this.props.editUnit(unitId);
    }

    expandedUnitDataList() {
        const units = this.props.localState.unitDataList;
        let result = [];
        for (let i = 0; i < units.length; ++i) {
            result.push(units[i]);
            if (units[i].subunits && units[i].subunits.length > 0) {
                result = result.concat(units[i].subunits);
            }
        }
        return result;
    }

    _checkAllUnitSaved(silent) {
        const { editUnitId } = this.props.localState;
        const unitDataList = this.expandedUnitDataList();
        for (let i = 0; i < unitDataList.length; ++i) {
            const unit = unitDataList[i];
            if (unit.modified) {
                this.editErrorUnit(unit.id);
                if (!silent) {
                    MessageBox.danger({ text: this.props.t('pleaseSaveUnitsFirst'), duration: 5000 });
                }
                return false;
            }
        }
        return true;
    }

    async _checkAllUnitSavedAsync(silent) {
        const { editUnitId } = this.props.localState;
        const unitDataList = this.expandedUnitDataList();
        for (let i = 0; i < unitDataList.length; ++i) {
            const unit = unitDataList[i];
            if (unit.modified) {
                this.editErrorUnit(unit.id);
                if (!silent) {
                    const unitId = unit.id;
                    const form = this.unitForms[unitId];
                    let showDefaultMsg = true;
                    if (form) {
                        const ok = await form.triggerValidation();
                        if (ok) {
                            const skipValidate = unit.skipValidate ? true : false;
                            if (!this.buildFormData(unit, form.getValues({nest: true}), silent, skipValidate)) {
                                showDefaultMsg = false;
                            }
                        }
                    }

                    if (showDefaultMsg) {
                        /*
                        MessageBox.danger({ text: this.props.t('pleaseSaveUnitsFirst'), duration: 5000 });
                        */
                        const [index, subIndex] = this.findUnitIndexById(unit.id);
                        MessageBox.danger({ text: this.props.t('unitHasInvalidData', {index: index + 1}), duration: 5000 });
                    }
                }
                return false;
            }
        }
        return true;
    }

    async _handleSaveAll(silent) {
        if (this.isActionExecuting(ActionTypes.SAVE_UNIT_ASYNC) ||
            this.isActionExecuting(ActionTypes.SAVE_UNIT_SILENT_ASYNC) ||
            this._savingPendingUnits)
        {
            return;
        }

        const { editUnitId } = this.props.localState;
        const unitDataList = this.expandedUnitDataList();

        /*
        if (editUnitId) {
            const form = this.unitForms[editUnitId];
            const unit = this.findUnitById(editUnitId);
            if (form && unit) {
                form.handleSubmit((newFormData) => {
                    this.onSaveForm(unit, newFormData);
                    setTimeout(this._handleSave, 0);
                })();
                return;
            }
        }
        */

        if (unitDataList.length === 0) {
            if (!silent) {
                MessageBox.danger({ text: this.props.t('pleaseAddUnits'), duration: 5000 });
            }
            return;
        }

        let modifiedCount = 0;
        let showErrorMessage = silent ? false : true;
        this._savingPendingUnits = true;
        for (let i = 0; i < unitDataList.length; ++i) {
            const unit = unitDataList[i];
            if (!unit.modified) {
                continue;
            }

            modifiedCount += 1;
            let r = await this._handleSaveUnit(unit, showErrorMessage ? false : true);
            if (this._abortSavingUnits) {
                break;
            }

            if (r) {
                if (showErrorMessage) {
                    this.editErrorUnit(unit.id);
                }
                showErrorMessage = false;
            }
        }

        this._savingPendingUnits = false;
        if (0 === modifiedCount) {
            MessageBox.success({ text: this.props.t('unitSaved'), duration: 5000 });
        }
    }

    _handleLoadScreenViewAsyncDone = (vo) => {
        const { composition } = this.localVars.navParams;
        const { unitTypeList, unitDataList } = this.props.localState;
        if (composition && unitDataList.length === 0) {
            for (let i = 0; i < unitTypeList.length; ++i) {
                if (unitTypeList[i].id === 'PSSD1') {
                    const { ownerType, ownerId } = this.localVars.navParams;
                    const unitType = unitTypeList[i];
                    const data = UnitView.defaultData(unitType.id);
                    const index = -1;
                    this.props.addUnit(index, {unitType, ownerType, ownerId: null, data});
                    this._lastAddedUnitIndex = index;
                    break;
                }
            }
        }
    };

    _handleChangeTitleAsyncDone = (vo) => {
        MessageBox.success({ text: this.props.t('changeTitleSuccess'), duration: 5000 });
    };

    _handleDeleteUnitAsyncDone = (vo) => {
        MessageBox.success({ text: this.props.t('unitDeleted'), duration: 5000 });
    };

    _handleSaveUnitAsyncDone = (vo) => {
        MessageBox.success({ text: this.props.t('unitSaved'), duration: 5000 });
    };

    _handleBatchAddUnitTask = (vo) => {
        this.props.batchAddUnitTask(vo);
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleBatchAddUnitTaskAndCreate = (vo) => {
        this.props.batchAddUnitTask(vo);
        this.props.recreate();
    }

    _handleBatchAddUnitAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        if (action.error.message === "NETWORK_ERROR") {
            this.displayError({message: this.props.t('networkError')});
        } else {
            this.displayError(action.error);
        }
    }
}

function EditForm(props) {
    const { duration, unitType } = props.localState;
    const { register, handleSubmit, errors, clearError } = useForm();

    const formHotKeysHandler = e => {
        e = e || window.event;
        if (e.keyCode === 83 && e.altKey) {//alt+s,alt+S
            document.getElementById("saveBtn").click();
        }
        if (e.keyCode === 67 && e.altKey) {//alt+s,alt+S
            document.getElementById("saveAndCreateBtn").click();
        }
        if (e.keyCode === 82 && e.altKey) {//alt+r,alt+R
            document.getElementById("resetBtn").click();
        }
        if (e.keyCode === 81 && e.altKey) {//alt+q,alt+Q
            document.getElementById("cancelBtn").click();
        }
    };

    const bindHotkeys = setInterval(() => {
        const unitForm = document.getElementById("unitForm");
        if (unitForm) {
            const inputs = unitForm.querySelectorAll("input,textarea");
            Array.from(inputs).map(e => e.onkeydown = formHotKeysHandler)
            clearInterval(bindHotkeys);
        }
    }, 100);

    window.onkeydown = formHotKeysHandler;

    return (

        <form id="unitForm">
            <Card className="shadow">
                <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                        <Col xs="6">
                            <h3 className="mb-0">{props.t("batchAdd", { unitType })}</h3>
                        </Col>
                        <Col className="text-right" xs="6">
                            <button id="saveBtn" type="submit" className="btn btn-info btn-sm" onClick={handleSubmit(props.onSave)}>{props.t("save") + "(S)"}</button>
                        &nbsp;
                        <button id="saveAndCreateBtn" type="submit" className="btn btn-success btn-sm" onClick={handleSubmit(props.onSaveAndCreate)}>{props.t("saveandcreate") + "(C)"}</button>
                        &nbsp;
                        <button id="resetBtn" type="reset" className="btn btn-default btn-sm">{props.t("reset") + "(R)"}</button>
                        &nbsp;
                        <button id="cancelBtn" type="button" className="btn btn-default btn-sm" onClick={props.onCancel}>{props.t("cancel") + "(Q)"}</button>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("duration")}</label>
                                    <input name="duration" type="text" className="form-control-alternative form-control"
                                        defaultValue={duration}
                                        ref={register({
                                            required: true,
                                            validate: {
                                                message: value => {
                                                    if (!_.isNumber(value)) {
                                                        value = _.toNumber(value);
                                                        if (value < 0 || isNaN(value))
                                                            return props.t("shouldLargerThanZero");
                                                    }
                                                    return clearError();
                                                }
                                            }
                                        })}
                                    />
                                    {errors.duration && <span className="text-danger">{errors.duration.message || props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("content")}</label>
                                    <textarea name="content" rows="10" className="form-control-alternative form-control"
                                        ref={register({ required: true })} />
                                    {errors.content && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </form>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
        changeTitleAsync: title => dispatch(Actions.changeTitleAsync(title)),
        deleteUnitAsync: (unitId) => dispatch(Actions.deleteUnitAsync(unitId)),
        saveUnitSilentAsync: (vo, modifySeq) => dispatch(Actions.saveUnitSilentAsync(vo, modifySeq)),
        saveUnitAsync: (vo, modifySeq) => dispatch(Actions.saveUnitAsync(vo, modifySeq)),
        abortSaveUnitSilentAsync: () => dispatch(Actions.saveUnitSilentFailure(new Error("abort"))),
        abortSaveUnitAsync: () => dispatch(Actions.saveUnitFailure(new Error("abort"))),
        reorderAsync: (unitId, toIndex) => dispatch(Actions.reorderAsync(unitId, toIndex)),
        batchAddUnitAsync: vo => dispatch(Actions.batchAddUnitAsync(vo)),
        batchAddAndCreateUnitAsync: vo => dispatch(Actions.batchAddAndCreateUnitAsync(vo)),
        selectUnitType: unitType => dispatch(Actions.selectUnitType(unitType)),
        batchAddUnitTask: vo => dispatch(TaskActions.batchAddTask(vo, TaskTypes.SAVE_UNIT)),
        addSaveUnitTask: vo => dispatch(TaskActions.addTask(vo, TaskTypes.SAVE_UNIT)),
        addUnit: (index, vo, cb) => dispatch(Actions.addUnit(index, vo, cb)),
        showAddSubUnit: (unitId, show) => dispatch(Actions.showAddSubUnit(unitId, show)),
        addSubUnit: (unitId, vo, cb) => dispatch(Actions.addSubUnit(unitId, vo, cb)),
        moveUnit: (unitId, toIndex) => dispatch(Actions.moveUnit(unitId, toIndex)),
        updateUnit: (unitId, formData) => dispatch(Actions.updateUnit(unitId, formData)),
        changeUnitType: (vo) => dispatch(Actions.changeUnitType(vo)),
        editUnit: (unitId) => dispatch(Actions.editUnit(unitId)),
        cancelEdit: () => dispatch(Actions.cancelEdit()),
        deleteUnit: (unitId) => dispatch(Actions.deleteUnit(unitId)),
        deleteAllUnits: () => dispatch(Actions.deleteAllUnits()),
        showErrorUnits: (units) => dispatch(Actions.showErrorUnits(units)),
        recreate: () => dispatch(Actions.recreate()),
    };
};

//提前load所有unit的i18n namespace, 防止在添加单元时候的闪屏效果
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(Helper.getI18nNSWithAllUnitView(uid))(SimpleBatchAddScreen));
